import React from 'react';
import { InputText } from 'components/inputText/inputText';
import { formatText } from 'core/i18n';

const isRequired = value => value && value.length;
const isValidYear = value => value.length === 4;
export const BirthYear = ({ userProfile, userProfileForm, formActions, validateGroups, onFocus, onBlur }) => {
    return (
        <div className="col-xs-6 input-yeard last-col">
            <InputText
                profileModel="userProfile.birthYear"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                name="birthYear"
                placeholder={formatText('field-birthYear')}
                maxLength={4}
                disabled={userProfile?.birthDayDisabled}
                onlyDigits
                validations={{
                    required: isRequired,
                    valid: isValidYear,
                }}
                isValidated={() => validateGroups('birthYear', true)}
                isNotValidated={() => validateGroups('birthYear', false)}
                messagesError={{ required: '' }}
                userProfileForm={userProfileForm}
                userProfile={userProfile}
                formActions={formActions}
                onFocus={onFocus}
                onBlur={onBlur}
            />
        </div>
    );
};
